module.exports = "/_next/static/resources/photo-2-fc90e78b94a570b80d1655602441f34c.webp";